document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById('subsidyInput');
    const houseInput = document.getElementById('subsidyNo');
    const dataInput = document.getElementById('subsidyDataInput');
    const button = document.getElementById('subsidyBtn');
    const result = document.getElementById('subsidyResult');
    const confirmPositive = document.querySelector(".subsidy-check__confirmation-positive");
    const confirmNegative = document.querySelector(".subsidy-check__confirmation-negative");
    const customContent = document.querySelector(".subsidy-check__custom-content");
    const adviceForm = document.querySelector(".subsidy-check__form");

    if (input && dataInput && button && result) {
        let data = [];
        let csvData = "";
        const dataUrl = dataInput.value;

        // Fetch the external CSV file & convert to JSON
        fetch(dataUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }
                return response.text();
            })
            .then(csvText => {
                csvData = csvText; // Store fetched CSV data
                convertCSVData();
            })
            .catch(error => {
                console.error('Error fetching CSV:', error);
            });

        async function convertCSVData()
        {
            data = await csvJSON(csvData);
        }

        function csvJSON(text, quoteChar = '"', delimiter = ',')
        {
            var rows=text.split("\n");
            var headers=rows[0].split(",");

            const regex = new RegExp(`\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`, 'gs');

            const match = line => [...line.matchAll(regex)]
                .map(m => m[2])
                .slice(0, -1);

            var lines = text.split('\n');
            const heads = headers ?? match(lines.shift());
            lines = lines.slice(1);

            return lines.map(line => {
                return match(line).reduce((acc, cur, i) => {
                    // replace blank matches with `null`
                    const val = cur.length <= 0 ? null : Number(cur) || cur;
                    const key = heads[i] ?? `{i}`;
                    return { ...acc, [key]: val };
                }, {});
            });
        }

        // Search function
        button.addEventListener('click', () => {
            const inputValue = parseInt(input.value, 10); // Get input as integer

            if (input.value === '' || houseInput.value === '') {
                return;
            }

            if (!data.length) {
                result.textContent = 'Data is not loaded yet. Please try again.';
                return;
            }

            // Search for the number in the JSON data
            const foundItem = data.find(item => item.zipcode === inputValue);

            if (foundItem && foundItem.zipcode_amount) {
                if (result) {
                    result.textContent = "€" + `${foundItem.zipcode_amount}` + ",-*";
                }

                if (confirmPositive && confirmNegative) {
                    confirmPositive.style.display = "block";
                    confirmPositive.style.visibility = "visible";
                    confirmNegative.style.display = "none";
                    confirmNegative.style.visibility = "hidden";

                    display_advice_form();
                }
            } else {
                if (confirmPositive && confirmNegative) {
                    confirmPositive.style.display = "none";
                    confirmPositive.style.visibility = "hidden";
                    confirmNegative.style.display = "block";
                    confirmNegative.style.visibility = "visible";

                    display_advice_form();
                }
            }
        });
    }

    function display_advice_form() {
        adviceForm.style.display = "block";
        adviceForm.style.visibility = "visible";

        if (customContent) {
            customContent.style.display = "none";
            customContent.style.visibility = "hidden";
        }

        let postalField = document.querySelector(".subsidy-check__postal-field .ginput_container_text input");
        let houseNrField = document.querySelector(".col-huis input");

        if (postalField) {
            postalField.value = input.value;
            houseNrField.value = houseInput.value;
        }

        // Trigger change on "house number" field to update the form
        let sacNumberInput = document.querySelector('.sac-number input');
        if (sacNumberInput.value !== '') {
            let event = new Event('change', {
                bubbles: true,
                cancelable: true
            });
            sacNumberInput.dispatchEvent(event);
        }
    }
});
